import React, { FC, useEffect, useRef, useState } from 'react';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';

interface IProps extends WithStyles<typeof styles> {
  active: boolean;
  onClick: () => void;
}

const styles = ({ custom }: Theme) =>
  createStyles({
    '@global @keyframes heart': {
      '0%': { transform: 'scale(1)' },
      '33%': { transform: 'scale(.5)' },
      '66%': { transform: 'scale(1.3)' },
      '100%': { transform: 'scale(1)' },
    },
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 30,
      height: 30,
      cursor: 'pointer',
    },
    icon: {
      fontSize: 24,
    },
    favorite: {
      fill: custom.palette.redBright,
    },
    favoriteBorder: {
      fill: custom.palette.grey2,
      '&:hover': {
        fill: custom.palette.black2,
      },
    },
    favoriteChanged: {
      animation: 'heart 600ms ease-in-out',
    },
  });

const Heart: FC<IProps> = ({ active, onClick, classes }) => {
  const [changed, setChanged] = useState(false);
  const hasMountRan = useRef(false);

  useEffect(() => {
    if (!hasMountRan.current) {
      hasMountRan.current = true;
      return () => {
        hasMountRan.current = active;
      };
    }

    setChanged(active);
    return () => {
      hasMountRan.current = active;
    };
  }, [active]);

  const favoriteBorderClasses = classNames(classes.icon, classes.favoriteBorder);
  const favoriteClasses = classNames(classes.icon, classes.favorite, {
    [classes.favoriteChanged]: changed,
  });

  return (
    <div
      data-testid="post-actions-like"
      role="button"
      className={classes.wrapper}
      onClick={onClick}
    >
      {active ? (
        <Favorite className={favoriteClasses} />
      ) : (
        <FavoriteBorder className={favoriteBorderClasses} />
      )}
    </div>
  );
};

export default withStyles(styles)(Heart);
